"use strict";

exports.__esModule = true;
exports.default = replaceParameters;

var _router = require("../../../constants/router");

function replaceParameters(str, parameters) {
  return str.replace(_router.constraintRegexp, function (match, constraintName) {
    var _parameters$constrain;

    return (_parameters$constrain = parameters[constraintName]) != null ? _parameters$constrain : "";
  });
}